export class TokenIntegrador {
    tokenMP: string;
    marketPlace: boolean;
}